import React from 'react';
import { useSelector } from 'react-redux';

import Header from '@/views/components/Header/Header';
import Footer from '@/views/components/Footer/Footer';

import styles from '@/views/pages/CookiesInfo/CookiesInfo.module.scss';

const CookiesInfo = () => {
	const { dict } = useSelector((state) => state.app);
	const { isLoggedIn } = useSelector(state => state.auth);

	return (
		<div className={ styles[`cookies-info--wrapper`] }>
			<Header 
				narrow={ false } 
				noLoggedInLinks={ !isLoggedIn } 
			/>
			<main className={ styles[`cookies-info--main`] }>
				<div className={ styles[`cookies-info--container`] }>
					<h1 className={ styles[`cookies-info--title`] }>
						{dict.cookiesInfo.title}
					</h1>
					<p className={ styles[`cookies-info--desc`] }
						dangerouslySetInnerHTML={ { __html: dict.cookiesInfo.text } } />
				</div>
			</main>
			<Footer 
				narrow={ false } 
				noLoggedInLinks={ !isLoggedIn } 
			/>
		</div>
	);
};
export default CookiesInfo;